<template>
  <main class="screen">
    <h2>The tents are open</h2>

    <ol class="scores">
      <li
        v-for="row in scores"
        :key="row.id"
        class="score"
        :class="{ 'score--winner': row.isWinner, 'score--me': row.id === me?.id }"
      >
        <span class="score__rank">{{ row.rank }}</span>
        <span class="score__name">{{ row.name }}</span>
        <span class="score__parts">
          <span :title="`${row.tent} treasure`"><i class="gem" aria-hidden="true" />{{ row.tent }}</span>
          <span v-if="row.artifacts" :title="`${row.artifacts} artifacts, worth ${row.artifactPoints}`">
            {{ row.artifacts }}<i class="idol" aria-hidden="true" />{{ row.artifactPoints }}
          </span>
        </span>
        <span class="score__total">{{ row.total }}</span>
      </li>
    </ol>

    <p class="muted">{{ headline }}</p>

    <!-- p3: any artifact still on the path when a round ended is gone for
         good. Worth saying, because "we saw five artifacts and only two got
         home" is otherwise a mystery. -->
    <p v-if="game.artifactsLost.length" class="muted">
      {{ game.artifactsLost.length }} artifact<template v-if="game.artifactsLost.length > 1">s</template>
      left behind in the dark, lost for good.
    </p>

    <div class="screen__actions">
      <button v-if="!isOnline" class="primary" @click="$store.dispatch('newGame', {})">Again</button>
      <button class="secondary" @click="leave">{{ isOnline ? 'Back to the menu' : 'Done' }}</button>
    </div>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ARTIFACT_EARLY_VALUE, ARTIFACT_LATE_VALUE } from '@/engine/constants';
import { listOf } from '@/engine/actions/turnActions';

// Final scoring, p4: "the Tents are opened and players count their treasures".
//
// This is the first and only moment anyone's tent total is visible - see
// SeatList for why. The breakdown is shown rather than just the total because
// the artifact half of it is the part people argue about (5 each for the
// first three home, 10 after that, counted across the whole table).
export default {
  name: 'ScoreSheet',
  computed: {
    ...mapState(['game']),
    ...mapGetters(['scores', 'me', 'isOnline']),
    headline() {
      const winners = this.scores.filter((row) => row.isWinner);
      if (!winners.length) return '';
      if (winners.length > 1) {
        // p4 says "if still tied, play again!", which software can't make
        // anyone do - so a tie that survives the artifact count is shared.
        return `${listOf(winners.map((w) => w.name))} tie, artifacts and all.`;
      }
      const [winner] = winners;
      const mine = winner.id === this.me?.id;
      return mine
        ? `You got out richest, with ${winner.total}.`
        : `${winner.name} got out richest, with ${winner.total}.`;
    },
    artifactValues() {
      return `${ARTIFACT_EARLY_VALUE} then ${ARTIFACT_LATE_VALUE}`;
    },
  },
  methods: {
    leave() {
      if (this.isOnline) this.$store.dispatch('leaveRoom');
      else this.$store.dispatch('abandonGame');
    },
  },
};
</script>
